import { Component } from '@angular/core';

@Component({
  selector: 'app-admin-users',
  templateUrl: './users.component.html',
  styleUrls: ['../admin-layout.component.scss'],
})
export class UsersComponent {}
